import React, { FC } from 'react';
import Input from '@components/common/input';
import Select from '@components/phone/select';
import styles from './styles.module.scss';
import FormField from '@components/form_field';

interface IProps {
    label?: string;
    disabled?: boolean;
    readOnly?: boolean;
    section?: string;
    isForm?: boolean;
    phone_code?: string;
    phone_number?: string;
    onCodeChange?: (value: string) => void;
    onPhoneChange?: (value: string) => void;
    selectSize?: 'small' | 'large';
}

const Phone: FC<IProps> = ({
    label,
    isForm = true,
    phone_code,
    phone_number,
    onPhoneChange,
    onCodeChange,
    disabled,
    readOnly,
    section,
    selectSize = 'large'
}) => {
    return (
        <div className={styles.main_wrapper}>
            <div className={styles.wrapper}>
                {isForm ? (
                    <FormField
                        name={`${section ? `${section}.` : ''}phone_code`}
                        renderComponent={({ value, onChange }) => (
                            <Select
                                value={value}
                                onChange={onChange}
                                disabled={disabled}
                                readOnly={readOnly}
                                selectSize={selectSize}
                            />
                        )}
                    />
                ) : (
                    <Select
                        value={phone_code}
                        onChange={onCodeChange}
                        disabled={disabled}
                        readOnly={readOnly}
                        selectSize={selectSize}
                    />
                )}
                {isForm ? (
                    <FormField
                        name={`${section ? `${section}.` : ''}phone_number`}
                        renderComponent={(props) => (
                            <Input
                                {...props}
                                full
                                readOnly={readOnly}
                                inputClassName={styles.input}
                                disabled={disabled}
                                mask="(999) 999 9999"
                                label={label}
                            />
                        )}
                    />
                ) : (
                    <Input
                        value={phone_number}
                        onChange={onPhoneChange}
                        full
                        readOnly={readOnly}
                        inputClassName={styles.input}
                        disabled={disabled}
                        mask="(999) 999 9999"
                        label={label}
                    />
                )}
            </div>
        </div>
    );
};

export default Phone;
